import NP, {ValueChangedEventArgs} from "../../1. Core/NP";
import Control from "../../1. Core/Control";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import CreateUserDlg from "./CreateUserDlg";
import {ServerAPI} from "../../1. Core/ServerAPI";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import "./UsersPanel.scss";
import PlayerRatingFilterPanel from "./PlayerRatingFilterPanel";
import {UsersResponse} from "../../5. Fantasy/types";


export default class PlayerRatingTable extends Control {
    private _Offset: number;
    private _Count: number;
    private _FilterText: string;
    private _topAppBar: TopAppBar;
    private _list: DataTable;
    private _filtersPanel: PlayerRatingFilterPanel;
    private _dataWithFiltersNode: HTMLElement;


    constructor(settings?: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        super._initFields(settings);
    }

    _render() {
        this.np_render();

        this._Offset = 0;
        this._Count = 100;
        this._FilterText = "";
        this._topAppBar = new TopAppBar({
            Caption: 'Players Rating',
            ParentNode: this._root,
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            ShowSearchButton: true,
            EvHideSearch: () => this.filterItems(null),
            EvSearch: (s: TopAppBar, e: ValueChangedEventArgs) => this.filterItems(e.Value),
            RightItems: [{
                ToolTip: NP.RM.getString('AddSingleUser'),
                FontImage: NP.FontImages.add,
                EvClick: () => {
                    (new CreateUserDlg({
                        AutoDestroy: true,
                        EvUserCreated: () => this.refresh()
                    })).show();
                }
            }]
        });


        let columns =
            [{
                Content: "Id",
                PropertyContent: 'id',
                Width: '70px'
            },  {
                Content: 'Login',
                PropertyContent: 'firstName',
                Width: '100px'
            },{
                Content: 'Email',
                PropertyContent: 'email',
                Width: 'calc(100% - 150px - 150px - 100px)'
            }, {
                Content: NP.RM.getString('Diamonds'),
                PropertyContent: 'pts',
                Width: '150px'
            }, {
                Content: 'coins',
                PropertyContent: 'coins',
                Width: '150px'
            }];


        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');
        this._list = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            ShowPaginator: true,
            EnableSort: false,
            EvPaginatorLeftClick: () => {
                this._Offset -= this._Count;
                this.refresh();
            },
            EvPaginatorRightClick: () => {
                this._Offset += this._Count;
                this.refresh();
            },
            Class: 'app-list--avatars',
            ShowSettingsButton: true,
            Columns: columns,
        });



        this._filtersPanel = new PlayerRatingFilterPanel({
            ParentNode: this._dataWithFiltersNode,
            Width: 280,
            EvFilterSortChanged: () => this.refresh()
        });

        this._filtersPanel.setIsVisible(true)
    }


    getTopAppBar() {
        return this._topAppBar;
    }


    setHeight(value: number) {
        super.setHeight(value);
        if (this._list)
            this._list.setHeight(this._Height - 64);

    }

    setWidth(value: number) {
        super.setWidth(value);

        if (this._filtersPanel.getIsVisible())
            value = value - 280;

        if (this._list)
            this._list.setWidth(value);

    }

    filterItems(value: string) {
        this._FilterText = value;
        this.refresh();
    }

    formatNum(value: number): string {
        if (value == null) return '';
        return new Intl.NumberFormat('en-US', {
            useGrouping: true,
        }).format(value);
    }

    async refresh() {
        let request = {
            offset: this._Offset, count: this._Count,
            filterText: this._FilterText || '',
            ...this._filtersPanel.getFilterData()
        }
        let res = await ServerAPI.post<UsersResponse>("/users/players/rating", request)

        this._list.setRows(res.users.map(it => ({
            ...it,
            pts: this.formatNum(it.pts),
            coins: this.formatNum(it.coins)
        })));

        this._list.updatePagCaption(`${this._Offset + 1} - ${Math.min(this._Offset + this._Count, this._Offset + res.users.length)}`);
        this._list.getRightPagButton().setEnabled(res.users.length == this._Count);
        this._list.getLeftPagButton().setEnabled(this._Offset > 0);
    }
}


